import React, { useState } from 'react';
import Header from '../../components/common/Header';
import Button from '../../components/ui/Button';
import EditText from '../../components/ui/EditText';
import Slider from '../../components/ui/Slider';

const PetProfile = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [email, setEmail] = useState('');

  const petImages = [
    '/images/img_image_2.png',
    '/images/img_image_4.png',
    '/images/img_image_3.png',
    '/images/img_image_5.png',
    '/images/img_image_6.png',
    '/images/img_image_7.png',
    '/images/img_image_8.png'
  ];

  const customerImages = [
    '/images/img_image_22.png',
    '/images/img_image_22_340x248.png',
    '/images/img_image_22_1.png',
    '/images/img_image_22_2.png',
    '/images/img_image_22_340x108.png'
  ];

  const relatedPets = [
    {
      id: 'MO231',
      name: 'MO231 - Pomeranian White',
      gene: 'Male',
      age: '02 months',
      price: '6.900.000 VND',
      image: '/images/img_image_2_264x264.png'
    },
    {
      id: 'MO502',
      name: 'MO502 - Poodle Tiny Yellow',
      gene: 'Female',
      age: '02 months',
      price: '3.900.000 VND',
      image: '/images/img_image_2_1.png'
    },
    {
      id: 'MO102',
      name: 'MO102 - Poodle Tiny Sepia',
      gene: 'Male',
      age: '02 months',
      price: '4.000.000 VND',
      image: '/images/img_image_3_264x264.png'
    },
    {
      id: 'MO512',
      name: 'MO512 - Alaskan Malamute Grey',
      gene: 'Male',
      age: '02 months',
      price: '8.900.000 VND',
      image: '/images/img_image_4_264x264.png'
    }
  ];

  const petDetails = [
    { label: 'SKU', value: ': #1000078' },
    { label: 'Gender', value: ': Female' },
    { label: 'Age', value: ': 2 Months' },
    { label: 'Size', value: ': Small' },
    { label: 'Color', value: ': Appricot & Tan' },
    { label: 'Vaccinated', value: ': Yes' },
    { label: 'Dewormed', value: ': Yes' },
    { label: 'Cert', value: ': Yes (MKA)' },
    { label: 'Microchip', value: ': Yes' },
    { label: 'Location', value: ': Vietnam' },
    { label: 'Published Date', value: ': 12-Oct-2022' },
    { 
      label: 'Additional Information', 
      value: ': Pure breed Shih Tzu.\r\n  Good body structure.\r\n  With MKA cert and Microchip.\r\n  Father from champion lineage.' 
    }
  ];

  const handlePrevImage = () => {
    setCurrentImageIndex(prev => prev === 0 ? petImages?.length - 1 : prev - 1);
  };

  const handleNextImage = () => {
    setCurrentImageIndex(prev => prev === petImages?.length - 1 ? 0 : prev + 1);
  };

  return (
    <div className="flex flex-col gap-[20px] justify-start items-center w-full bg-global-4">
      <Header />
      <div className="flex flex-col gap-[20px] justify-start items-center w-full">
        <div className="flex flex-col gap-[20px] justify-start items-center w-full max-w-[1182px] mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Main Content */}
          <div className="flex flex-col lg:flex-row gap-4 lg:gap-[28px] justify-start items-start w-full">
            
            {/* Left Column - Images */}
            <div className="flex flex-col gap-[16px] justify-start items-center w-full lg:w-auto">
              <div className="flex flex-col gap-[12px] justify-start items-center w-full">
                
                {/* Main Image with Navigation */}
                <div className="relative flex justify-center w-full max-w-[560px]">
                  <img 
                    src={petImages?.[currentImageIndex]} 
                    className="w-full h-[300px] sm:h-[400px] lg:w-[560px] lg:h-[476px] object-cover rounded-[10px]" 
                    alt="Pet main image" 
                  />
                  
                  {/* Navigation Arrows */}
                  <div className="absolute top-1/2 transform -translate-y-1/2 flex justify-between items-center w-full px-2 sm:px-4">
                    <button 
                      onClick={handlePrevImage}
                      className="relative flex justify-center items-center w-[42px] h-[42px] sm:w-[52px] sm:h-[52px]"
                    >
                      <div className="absolute w-[32px] h-[32px] sm:w-[42px] sm:h-[42px] bg-global-7 rounded-[20px]"></div>
                      <img 
                        src="/images/img_arrow_caret_left_sm.svg" 
                        className="relative w-[42px] h-[42px] sm:w-[52px] sm:h-[52px]" 
                        alt="Previous" 
                      />
                    </button>
                    
                    <button 
                      onClick={handleNextImage}
                      className="relative flex justify-center items-center w-[42px] h-[42px] sm:w-[52px] sm:h-[52px]"
                    >
                      <div className="absolute w-[32px] h-[32px] sm:w-[42px] sm:h-[42px] bg-global-7 rounded-[20px]"></div>
                      <img 
                        src="/images/img_arrow_caret_left_sm.svg" 
                        className="relative w-[42px] h-[42px] sm:w-[52px] sm:h-[52px] rotate-180" 
                        alt="Next" 
                      />
                    </button>
                  </div>
                </div>
                
                {/* Thumbnail Images */}
                <div className="flex justify-center items-center w-full overflow-x-auto">
                  <div className="flex justify-center items-center gap-[12px] min-w-max">
                    {petImages?.map((image, index) => (
                      <img 
                        key={index}
                        src={image} 
                        className={`w-[60px] h-[60px] sm:w-[80px] sm:h-[80px] lg:w-[94px] lg:h-[94px] object-cover rounded-[6px] cursor-pointer ${
                          index === currentImageIndex ? 'ring-2 ring-global-1' : ''
                        }`}
                        alt={`Pet thumbnail ${index + 1}`}
                        onClick={() => setCurrentImageIndex(index)}
                      />
                    ))}
                  </div>
                </div>
              </div>
              
              {/* Guarantee Section */}
              <div className="flex flex-col sm:flex-row justify-center items-center gap-4 w-full bg-gradient-to-r from-global-3 to-[#ffe6b9] rounded-[10px] p-4">
                <div className="flex gap-[8px] justify-center items-center">
                  <img src="/images/img_frame_110.svg" className="w-[24px] h-[24px] sm:w-[30px] sm:h-[30px]" alt="Health guarantee" />
                  <span className="text-xs sm:text-sm lg:text-[14px] font-svn-gilroy font-bold leading-[15px] text-global-text3">
                    100% health guarantee for pets
                  </span>
                </div>
                <div className="flex gap-[8px] justify-center items-center">
                  <img src="/images/img_frame_110_amber_300.svg" className="w-[24px] h-[24px] sm:w-[30px] sm:h-[30px]" alt="ID guarantee" />
                  <span className="text-xs sm:text-sm lg:text-[14px] font-svn-gilroy font-bold leading-[15px] text-global-text3">
                    100% guarantee of pet identification
                  </span>
                </div>
              </div>
              
              {/* Share Section */}
              <div className="flex justify-center items-center w-full p-[6px]">
                <div className="flex justify-center items-center gap-[8px]">
                  <img src="/images/img_communication.svg" className="w-[20px] h-[20px]" alt="Share" />
                  <span className="text-sm lg:text-[14px] font-svn-gilroy font-bold leading-[15px] text-global-text3">
                    Share:
                  </span>
                </div>
                <div className="flex justify-start items-center gap-[16px] px-[10px] flex-1">
                  <img src="/images/img_facebook_negative.svg" className="w-[18px] h-[18px]" alt="Facebook" />
                  <img src="/images/img_twitter_negative.svg" className="w-[18px] h-[18px]" alt="Twitter" />
                  <img src="/images/img_instagram_negative.svg" className="w-[18px] h-[18px]" alt="Instagram" />
                  <img src="/images/img_youtube_negative.svg" className="w-[18px] h-[18px]" alt="YouTube" />
                </div>
              </div>
            </div>
            
            {/* Right Column - Pet Details */}
            <div className="flex flex-col gap-[18px] justify-start items-start w-full lg:flex-1 bg-global-6 border border-global-2 rounded-[20px] p-4 sm:p-5 lg:p-[22px]">
              
              {/* Breadcrumb */}
              <div className="flex justify-start items-center w-full flex-wrap gap-2">
                <span className="text-xs sm:text-sm lg:text-[14px] font-svn-gilroy font-medium leading-[15px] text-global-6">Home</span>
                <img src="/images/img_arrow_right.svg" className="w-[20px] h-[20px] sm:w-[24px] sm:h-[24px]" alt="Arrow" />
                <span className="text-xs sm:text-sm lg:text-[14px] font-svn-gilroy font-medium leading-[15px] text-global-6">Dog</span>
                <img src="/images/img_arrow_right.svg" className="w-[20px] h-[20px] sm:w-[24px] sm:h-[24px]" alt="Arrow" />
                <span className="text-xs sm:text-sm lg:text-[14px] font-svn-gilroy font-medium leading-[15px] text-global-6">Large Dog</span>
                <img src="/images/img_arrow_right.svg" className="w-[20px] h-[20px] sm:w-[24px] sm:h-[24px]" alt="Arrow" />
                <span className="text-xs sm:text-sm lg:text-[14px] font-svn-gilroy font-medium leading-[15px] text-global-6">Shiba Inu Sepia</span>
              </div>
              
              {/* Pet Info */}
              <div className="flex flex-col gap-[8px] justify-center items-start w-full">
                <span className="text-xs sm:text-sm lg:text-[14px] font-svn-gilroy font-medium leading-[15px] text-global-7">
                  SKU #1000078
                </span>
                <h1 className="text-lg sm:text-xl lg:text-[24px] font-svn-gilroy font-bold leading-[26px] text-global-text2">
                  Shiba Inu Sepia
                </h1>
                <span className="text-lg sm:text-xl lg:text-[20px] font-svn-gilroy font-bold leading-[21px] text-global-text3 mb-1">
                  34.000.000 VND
                </span>
              </div>
              
              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row justify-start items-center gap-3 sm:gap-[18px] w-full">
                <Button 
                  variant="primary"
                  className="w-full sm:w-auto bg-global-1 text-global-8 rounded-lg px-6 sm:px-7 py-2 sm:py-3"
                  onClick={() => {}}
                >
                  Contact us
                </Button>
                <button className="flex gap-[12px] justify-center items-center w-full sm:w-auto border-2 border-global-text3 rounded-lg px-6 sm:px-[26px] py-2 sm:py-[10px] hover:bg-global-text3 hover:text-global-8 transition-colors">
                  <img src="/images/img_communication_chatdots.svg" className="w-[20px] h-[20px] sm:w-[24px] sm:h-[24px]" alt="Chat" />
                  <span className="text-sm sm:text-base lg:text-[16px] font-svn-gilroy font-bold leading-[17px] text-global-text3">
                    Chat with Monito
                  </span>
                </button>
              </div>
              
              {/* Pet Details List */}
              <div className="flex flex-col w-full">
                {petDetails?.map((detail, index) => (
                  <div key={index} className="flex justify-center items-start w-full border-b border-global-2 py-2">
                    <div className="flex justify-start items-center px-[10px] w-auto min-w-[120px]">
                      <span className="text-xs sm:text-sm lg:text-[14px] font-svn-gilroy font-medium leading-[15px] text-global-6">
                        {detail?.label}
                      </span>
                    </div>
                    <div className="flex justify-start items-center px-[10px] flex-1">
                      <span className={`text-xs sm:text-sm lg:text-[14px] font-svn-gilroy font-medium text-global-6 ${
                        detail?.label === 'Additional Information' ? 'leading-[20px] whitespace-pre-line' : 'leading-[15px]'
                      }`}>
                        {detail?.value}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          
          {/* Customer Testimonials Slider */}
          <div className="relative flex justify-center w-full max-w-[1182px]">
            <Slider 
              title="Our lovely customer"
              className="w-full"
            >
              {customerImages?.map((image, index) => (
                <div key={index} className="flex-shrink-0 w-[180px] sm:w-[220px] lg:w-[248px]">
                  <img 
                    src={image} 
                    className="w-full h-[240px] sm:h-[280px] lg:h-[340px] object-cover rounded-[10px]" 
                    alt={`Customer ${index + 1}`} 
                  />
                </div>
              ))}
            </Slider>
            
            {/* Pagination Dots */}
            <div className="flex gap-[6px] justify-center items-center w-full mt-6 px-14">
              <div className="w-[18px] sm:w-[22px] h-[6px] sm:h-[8px] bg-global-1 rounded-[4px]"></div>
              <div className="w-[6px] sm:w-[8px] h-[6px] sm:h-[8px] bg-global-2 rounded-[4px]"></div>
              <div className="w-[6px] sm:w-[8px] h-[6px] sm:h-[8px] bg-global-2 rounded-[4px]"></div>
              <div className="w-[6px] sm:w-[8px] h-[6px] sm:h-[8px] bg-global-2 rounded-[4px]"></div>
              <div className="w-[6px] sm:w-[8px] h-[6px] sm:h-[8px] bg-global-2 rounded-[4px]"></div>
              <div className="w-[6px] sm:w-[8px] h-[6px] sm:h-[8px] bg-global-2 rounded-[4px]"></div>
            </div>
          </div>
        </div>
        
        {/* Related Pets Section */}
        <div className="flex flex-col gap-[20px] justify-start items-center w-full">
          <div className="flex flex-col sm:flex-row justify-center items-center w-full bg-global-6 py-8 sm:py-12 lg:py-[60px] px-4 sm:px-6 lg:px-14">
            <div className="flex flex-col justify-start items-start w-full max-w-[1182px]">
              <span className="text-sm sm:text-base lg:text-[16px] font-svn-gilroy font-medium leading-[17px] text-global-1 mb-2">
                What is new?
              </span>
              <h2 className="text-lg sm:text-xl lg:text-[24px] font-svn-gilroy font-bold leading-[26px] text-global-1 capitalize mb-6 sm:mb-8">
                See more puppies
              </h2>
              
              {/* Related Pets Grid */}
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-5 lg:gap-[20px] w-full overflow-x-auto">
                {relatedPets?.map((pet) => (
                  <div key={pet?.id} className="flex flex-col gap-[8px] justify-start items-center w-full sm:w-[280px] flex-shrink-0 bg-global-6 rounded-[12px] p-2 shadow-[0px_4px_28px_#00000014]">
                    <div className="flex flex-col justify-start items-center w-full bg-global-6 rounded-[10px] mt-2">
                      <img 
                        src={pet?.image} 
                        className="w-full max-w-[264px] h-[200px] sm:h-[240px] lg:h-[264px] object-cover rounded-[10px]" 
                        alt={pet?.name} 
                      />
                    </div>
                    
                    <div className="flex justify-start items-start w-full p-2">
                      <div className="flex flex-col gap-1 sm:gap-[6px] justify-center items-start w-full mb-3">
                        <h3 className="text-sm sm:text-base lg:text-[16px] font-svn-gilroy font-bold leading-[17px] text-global-text2">
                          {pet?.name}
                        </h3>
                        
                        <div className="flex justify-start items-center w-full">
                          <div className="flex justify-center items-center">
                            <span className="text-xs lg:text-[12px] font-svn-gilroy font-medium leading-[13px] text-global-6">
                              Gene:
                            </span>
                            <span className="text-xs lg:text-[12px] font-svn-gilroy font-bold leading-[13px] text-global-6 ml-1">
                              {pet?.gene}
                            </span>
                          </div>
                          
                          <div className="flex justify-start items-center flex-1 px-3">
                            <span className="text-xs lg:text-[12px] font-svn-gilroy font-medium leading-[13px] text-global-6">
                              Age:
                            </span>
                            <span className="text-xs lg:text-[12px] font-svn-gilroy font-bold leading-[13px] text-global-6 ml-1">
                              {pet?.age}
                            </span>
                          </div>
                        </div>
                        
                        <span className="text-sm lg:text-[14px] font-svn-gilroy font-bold leading-[15px] text-global-text2">
                          {pet?.price}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          
          {/* Newsletter Section */}
          <div className="flex flex-col justify-start items-center w-full">
            <div className="flex flex-col gap-[40px] justify-start items-center w-full max-w-[1182px] mx-auto px-4 sm:px-6 lg:px-8 mt-10">
              <div className="flex flex-col gap-[40px] justify-start items-center w-full">
                
                {/* Newsletter Signup */}
                <div className="flex flex-col lg:flex-row gap-4 lg:gap-[20px] justify-start items-center w-full bg-global-1 rounded-[16px] p-6 sm:p-8 lg:p-8">
                  <h2 className="text-lg sm:text-xl lg:text-[24px] font-svn-gilroy font-bold leading-[36px] text-global-8 capitalize w-full lg:w-[34%] text-center lg:text-left">
                    Register now so you do not miss our programs
                  </h2>
                  
                  <div className="flex flex-col sm:flex-row gap-3 lg:gap-[12px] justify-center items-center w-full lg:flex-1 bg-global-6 rounded-[14px] p-3">
                    <EditText
                      placeholder="Enter your Email"
                      value={email}
                      onChange={(e) => setEmail(e?.target?.value)}
                      className="flex-1 border border-global-7 rounded-[8px]"
                    />
                    <Button 
                      variant="primary"
                      className="w-full sm:w-auto bg-global-1 text-global-8 rounded-[8px] px-6 sm:px-[30px] py-3 sm:py-[14px]"
                      onClick={() => {}}
                    >
                      Subscribe Now
                    </Button>
                  </div>
                </div>
                
                {/* Footer */}
                <div className="flex flex-col sm:flex-row justify-between items-center w-full border-b border-global-2 pb-10">
                  <div className="flex flex-col sm:flex-row justify-start items-center w-full sm:flex-1 gap-4 sm:gap-[60px] mb-4 sm:mb-0">
                    <span className="text-sm sm:text-base lg:text-[16px] font-svn-gilroy font-medium leading-[17px] text-global-text2">
                      Home
                    </span>
                    <span className="text-sm sm:text-base lg:text-[16px] font-svn-gilroy font-medium leading-[17px] text-global-text2">
                      Category
                    </span>
                    <span className="text-sm sm:text-base lg:text-[16px] font-svn-gilroy font-medium leading-[17px] text-global-text2">
                      About
                    </span>
                    <span className="text-sm sm:text-base lg:text-[16px] font-svn-gilroy font-medium leading-[17px] text-global-text2">
                      Contact
                    </span>
                  </div>
                  
                  <div className="flex justify-end items-center gap-6 sm:gap-[40px]">
                    <img src="/images/img_facebook_negative_gray_900.svg" className="w-[20px] h-[20px] sm:w-[24px] sm:h-[24px]" alt="Facebook" />
                    <img src="/images/img_twitter_negative_gray_900.svg" className="w-[20px] h-[20px] sm:w-[24px] sm:h-[24px]" alt="Twitter" />
                    <img src="/images/img_instagram_negative_gray_900.svg" className="w-[20px] h-[20px] sm:w-[24px] sm:h-[24px]" alt="Instagram" />
                    <img src="/images/img_youtube_negative_gray_900.svg" className="w-[20px] h-[20px] sm:w-[24px] sm:h-[24px]" alt="YouTube" />
                  </div>
                </div>
                
                {/* Copyright */}
                <div className="flex flex-col sm:flex-row justify-center items-center w-full gap-4">
                  <span className="text-xs sm:text-sm lg:text-[14px] font-svn-gilroy font-medium leading-[20px] text-global-6">
                    © 2022 Monito. All rights reserved.
                  </span>
                  
                  <div className="flex flex-col gap-1 justify-center items-center sm:items-end flex-1 px-4 sm:px-[56px]">
                    <img src="/images/img_group.svg" className="w-[86px] h-[20px] sm:w-[114px] sm:h-[26px]" alt="Monito Logo" />
                    <img src="/images/img_group_teal_900.svg" className="w-[40px] h-[4px] sm:w-[54px] sm:h-[6px] mr-7" alt="Logo accent" />
                  </div>
                  
                  <span className="text-xs sm:text-sm lg:text-[14px] font-svn-gilroy font-medium leading-[20px] text-global-6">
                    Terms of Service          Privacy Policy
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PetProfile;